import React from "react";

/**
 * Lightweight suit-symbol colouring for plain strings (titles, labels, chips,
 * buttons...). House colours (classes defined in src/index.css):
 *   ♥ red, ♦ #B34A00, ♣ green, ♠ inherits the surrounding text colour (black on
 *   light pages, stays readable on dark ones).
 * Put `bc-suits-on-dark` on a dark-background ancestor to switch to the light
 * palette.
 *
 * Use this instead of importing TextWithColoredSuits from the (very large)
 * CountingTrumpsTrainer module in pages that don't otherwise need the trainer.
 */
const SUIT_CLASS = {
  "♠": "bc-suit bc-suit--s",
  "♥": "bc-suit bc-suit--h",
  "♦": "bc-suit bc-suit--d",
  "♣": "bc-suit bc-suit--c",
};

export function colourSuits(text) {
  if (text == null || text === "") return text;
  if (typeof text !== "string") return text;
  if (!/[♠♥♦♣]/.test(text)) return text;
  return text.split(/([♠♥♦♣])/).map((part, i) => {
    if (SUIT_CLASS[part]) {
      return (
        <span key={i} className={SUIT_CLASS[part]}>
          {part}
        </span>
      );
    }
    return part ? <React.Fragment key={i}>{part}</React.Fragment> : null;
  });
}

export default function SuitText({ text, children }) {
  const value = text != null ? text : children;
  return <>{colourSuits(value)}</>;
}
